import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button2 } from '../Button'
import CsvExportButton from '../CsvExportButton'
import FilterForm from './FilterForm'
import SearchInput from '../SearchInput'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { PermissionAction } from '../permissions'
import { useEffect, useState } from 'react'
import { useDebounce } from '@uidotdev/usehooks'
import { ImportData } from '../ImportData'
import { useTranslation } from 'react-i18next'
import { CFieldProps } from '@velocity/shared'
import BulkUpdateDropdown, { BulkUpdateProps } from './BulkUpdateDropdown'
import SearchFilter, { SearchFilterProps } from './SearchFilter'

type HeaderProps = {
  title: string
  createAction?: () => void
  createLabel?: string
  csvData?: any
  filterFields?: (CFieldProps | string)[]
  filterAble?: boolean
  searchAble?: boolean
  model?: string
  deleteIds?: string[] | { [key: string]: any }[]
  deleteAction?: (ids: any) => void
  params?: any
  updateParams?: (key: string, value: any) => void
  allowImport?: boolean
  extraButtonActions?: {
    title: string
    onClick: () => void
    btnStyle?: string
    rightIcon?: any
    loading?: boolean
  }[]
  bulkUpdate?: BulkUpdateProps
  searchFilter?: SearchFilterProps
  // filterOnChange?: (values: any, updateFn: any) => void
}
export const Header = ({
  title,
  createAction,
  createLabel,
  csvData,
  filterFields = [],
  filterAble = true,
  searchAble = true,
  model,
  deleteIds,
  deleteAction,
  params,
  updateParams,
  allowImport,
  extraButtonActions,
  // filterOnChange
  ...props
}: HeaderProps) => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState('')
  const [search, setSearch] = useState('')
  const searchInput = useDebounce(search, 500)
  useEffect(() => {
    if (updateParams) updateParams('search', searchInput)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput])

  return (
    <>
      <div className=' sm:flex p-3 justify-between'>
        <p className='text-[24px] font-medium'>{t(title)}</p>
        <div className='flex flex-col sm:flex-row sm:items-center gap-2'>
          {createAction && model && (
            <Button2
              title={createLabel || `Add ${title}`}
              onClick={createAction}
              model={model}
              action={PermissionAction.Create}
            />
          )}
          {extraButtonActions?.map((action, index) => (
            <Button2 key={index} {...action} />
          ))}
          {allowImport && model && (
            <Button2
              title={'Import ' + title}
              onClick={() => setShowModal('import')}
              model={model}
              action={PermissionAction.Create}
              btnStyle='outline'
            />
          )}
          {csvData && (
            <CsvExportButton
              data={csvData}
              filename={model}
              buttonText={t('Export as CSV')}
            />
          )}
        </div>
      </div>
      <div className='flex flex-col sm:grid sm:grid-cols-8 gap-4 border-dashed border-t p-3 no-print'>
        {filterAble && updateParams && (
          <FilterForm
            fields={filterFields}
            values={params?.filter}
            action={(val) => updateParams('filter', val)}
            // onChange={filterOnChange}
          />
        )}
        {searchAble && (
          <div className='col-span-7'>
            <SearchInput
              placeholder='Search ...'
              value={search}
              onChange={(e: any) => setSearch(e.target.value)}
            />
          </div>
        )}
      </div>
      {props.searchFilter && <SearchFilter {...props.searchFilter} />}
      {deleteIds?.length ?
        <div className='flex'>
          {deleteAction && model && (
            <div className='px-3'>
              <Button2
                title={`Delete {{count}} ${title}`}
                titleSlot={{ count: deleteIds.length }}
                onClick={() => deleteAction(deleteIds)}
                model={model}
                action={PermissionAction.Delete}
                rightIcon={<FontAwesomeIcon icon={faTrash} />}
                btnStyle='danger'
              />
            </div>
          )}
          {props.bulkUpdate && <BulkUpdateDropdown {...props.bulkUpdate} />}
        </div>
      : ''}
      {allowImport && model && (
        <ImportData
          setOpen={setShowModal}
          open={showModal}
          model={model}
          title={title}
        />
      )}
    </>
  )
}
